export enum NodeEnvironment {
  Development = 'development',
  Production = 'production',
  Testing = 'testing',
  Sandbox = 'sandbox',
  Staging = 'staging',
  Demo = 'demo',
}
